function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 8L7 11h1.5L5 14h2.5L3 17h7v4h4v-4h7l-4.5-3H19l-3.5-3H17l-2.5-3H16l-4-6-4 6h1.5z",
  fill: "currentColor"
});

var SvgLocationPark = function SvgLocationPark(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationPark;